import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AccountService {
  baseUrl: string = environment.API_SERVER;
  constructor(private _http: HttpClient) {}
  validateForgotPassword(payload) {
    return this._http.post(
      `${this.baseUrl}/auth/validate-old-forgot-password/`,
      payload.body
    );
  }

  uploadSignature(payload) {
    return this._http.post(
      `${this.baseUrl}/adhoc_payments/app_user_signature/`,
      payload.body
    );
  }

  updateSignature(payload) {
    return this._http.put(
      `${this.baseUrl}/adhoc_payments/app_user_signature/${payload.appUserId}/`,
      payload.body
    );
  }

  getSignature(payload) {
    return this._http.get(
      `${this.baseUrl}/adhoc_payments/app_user_signature/view/${payload.appUserId}/`
    );
  }
  getUserAvailiability(payload) {
    return this._http.get(
      `${this.baseUrl}/users/${payload.appUserId}/availability/`
    );
  }

  login(payload) {
    return this._http.post(`${this.baseUrl}/auth/login/`, payload.body);
  }

  changePassword(payload) {
    return this._http.put(
      `${this.baseUrl}/users/${payload.appUserId}/change-password/`,
      payload.body
    );
  }
  changeToAvailiable(payload) {
    return this._http.patch(
      `${this.baseUrl}/users/${payload.appUserId}/mark-available/`,
      payload.body
    );
  }
  changeToUnAvailiable(payload) {
    return this._http.patch(
      `${this.baseUrl}/users/${payload.appUserId}/mark-unavailable/`,
      payload.body
    );
  }
  updateUser(payload) {
    return this._http.put(
      `${this.baseUrl}/users/${payload.appUserId}/`,
      payload.body
    );
  }

  uploadUserPhotoBase(payload) {
    return this._http.post(
      `${this.baseUrl}/users/${payload.appUserId}/profile_photo_base64/`,
      payload.body
    );
  }

  uploadUserPhoto(payload) {
    return this._http.post(
      `${this.baseUrl}/users/${payload.appUserId}/profile_photo/`,
      payload.body
    );
  }

  changeSecondaryEmail(payload) {
    return this._http.patch(
      `${this.baseUrl}/users/${payload.appUserId}/profile/secondary_email/${payload.secondaryEmail}/`,
      payload.body
    );
  }
  changePrimaryEmail(payload) {
    return this._http.put(
      `${this.baseUrl}/users/${payload.appUserId}/profile/primary_email/`,
      payload.body
    );
  }
  changeUserName(payload) {
    return this._http.put(
      `${this.baseUrl}/users/${payload.appUserId}/profile/username/`,
      payload.body
    );
  }
}
